import Settings16 from '@carbon/icons-react/es/settings/16';
import View16 from '@carbon/icons-react/es/view/16';
import { Tooltip } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';
import { ProjectId } from 'api/models';
import { Project } from 'api/project';
import { Button } from 'components/atoms/button';
import {
  HideForCustomer,
  HideForPartner,
} from 'components/atoms/user-type-utils';
import { AvatarInviteTrigger } from 'components/organisms/projects/global-invite/avatar-invite-trigger';
import { getCustomerPreviewUrl, getProjectSettingsUrl } from 'utils/urls';
import { PlaceholderResolution } from '../placeholder-resolution';
import {
  CompanyLogo,
  HeaderContainer,
  RightMenuContainer,
  Title,
  TitleContainer,
} from './project-title.styles';

export const ProjectTitle = ({ project }: { project: Project }) => {
  const location = useLocation();
  const { pathname } = location;
  const {
    projectId,
    projectName,
    customer: { companyName, companyLogoUrl },
  } = project;

  return (
    <HeaderContainer>
      <TitleContainer>
        <CompanyLogo
          src={companyLogoUrl}
          name={companyName || projectName}
          size={32}
        />
        <Title data-cy="page.header.title">{projectName}</Title>
      </TitleContainer>

      <HideForCustomer>
        <RightMenuContainer size="small">
          <PlaceholderResolution project={project} />
          <div>
            <HideForPartner>
              <Tooltip
                title={
                  <FormattedMessage
                    id="projects.preview.menu.label"
                    values={{ company_name: companyName }}
                  />
                }
              >
                <Link
                  to={{
                    pathname: getCustomerPreviewUrl(pathname),
                  }}
                  target="_blank"
                  data-cy="link.customer-preview"
                >
                  <Button type="text" icon={<View16 />} />
                </Link>
              </Tooltip>
            </HideForPartner>
            <Tooltip title={<FormattedMessage id="projects.settings" />}>
              <Link
                data-cy="project.settings"
                to={getProjectSettingsUrl(ProjectId(projectId))}
              >
                <Button type="text" icon={<Settings16 />} />
              </Link>
            </Tooltip>
          </div>
          <AvatarInviteTrigger projectId={projectId} showButton />
        </RightMenuContainer>
      </HideForCustomer>
    </HeaderContainer>
  );
};
